import { Icon } from "@iconify/react";
import Dashboard from "./Dashboard";
import Configuration from "./Configuration";
import { useAppInfo } from "../../context/app";
import IntegrationDashboard from "./IntegrationDashboard";
import GetStarted from "./GetStarted";
import Support from "./Support";
import PrintfulApp from "./PrintfulApp";
import { SocketProvider } from "../../context/socket";

// Printful is the only app that gets the extra "App" tab below.
const PRINTFUL_APP_ID = "68b6bb88fac52f2b120cd9d6";

const useRoutes = () => {
  const [app] = useAppInfo();
  const routes = [
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Dashboard",
      key: "dashboard",
      route: "/dashboard",
      component: app?.featuresInclude?.includes("Conversation Providers") ? (
        <Dashboard />
      ) : (
        <IntegrationDashboard />
      ),
    },
    ...(app?.appId === PRINTFUL_APP_ID
      ? [
          {
            icon: <Icon icon="flowbite:grid-outline" className="menu-icon" />,
            title: "App",
            key: "app",
            route: "/app",
            component: <PrintfulApp />,
          },
        ]
      : []),
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Configuration",
      key: "configuration",
      route: "/configuration",
      component: <Configuration />,
    },
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Get Started",
      key: "get_started",
      route: "/get_started",
      component: <GetStarted />,
    },
    {
      icon: <Icon icon="mdi:headset" className="menu-icon" />,
      title: "Support",
      key: "support",
      route: "/support",
      component: (
        <SocketProvider>
          <Support />
        </SocketProvider>
      ),
    },
  ];
  return routes;
};

export default useRoutes;
